module.exports = __webpack_public_path__ + "static/img/H2B.4140859f.jpg";